import { DateOnly, DateTime, TimeOnly } from "../@client/System"

export function dateAndTimeOnlyToDateTime(
  date: DateOnly,
  time: TimeOnly
): DateTime {
  return `${date}T${time}` as DateTime
}
